class LoftyCartDrawer extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.cart-drawer__panel');
    this.lastTrigger = null;
    this.root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    document.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-cart-drawer-open]');
      if (openTrigger) { this.lastTrigger = openTrigger; this.open(); }
      if (event.target.closest('[data-cart-drawer-close]')) this.close();
      const qtyButton = event.target.closest('[data-cart-qty-change]');
      if (qtyButton) this.changeQuantity(qtyButton);
    });
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form.matches('[data-quick-add-form], [data-product-form]')) this.addToCart(event, form);
      if (form.matches('[data-cart-quantity-form]')) event.preventDefault();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
      if (this.classList.contains('is-open') && this.panel && window.LoftyLlama?.trapFocus) window.LoftyLlama.trapFocus(this.panel, event);
    });
  }
  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-lock');
    if (this.panel) this.panel.focus();
  }
  close() {
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-lock');
    this.lastTrigger?.focus();
  }
  async refresh() {
    const response = await fetch(`${this.root}?sections=cart-drawer`);
    const data = await response.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = html.querySelector('#CartDrawer');
    if (fresh) { this.innerHTML = fresh.innerHTML; this.panel = this.querySelector('.cart-drawer__panel'); }
    const cart = await fetch(`${this.root}cart.js`).then((r) => r.json());
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.classList.toggle('is-empty', Number(cart.item_count) === 0); });
    document.dispatchEvent(new CustomEvent('loftyllama:cart-refreshed'));
  }
  async addToCart(event, form) {
    if (!window.fetch || !window.FormData) return;
    const idInput = form.querySelector('[name="id"]');
    const errorEl = form.querySelector('[data-card-error]');
    if (idInput && !idInput.value) {
      event.preventDefault();
      if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Choose a size first.'; }
      return;
    }
    event.preventDefault();
    const button = form.querySelector('button[type="submit"], button[name="add"]');
    const original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding...'; }
    try {
      const response = await fetch(`${this.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Add failed');
      await this.refresh();
      this.open();
      if (button) button.textContent = 'Added';
      if (errorEl) errorEl.hidden = true;
    } catch (error) {
      if (button) button.textContent = 'Try again';
      if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Could not add this item. Try again.'; }
    } finally {
      if (button) setTimeout(() => { button.disabled = false; button.textContent = original; }, 900);
    }
  }
  async changeQuantity(button) {
    const form = button.closest('[data-cart-quantity-form]');
    if (!form) return;
    const input = form.querySelector('[name="quantity"]');
    const id = form.querySelector('[name="id"]').value;
    const delta = Number(button.dataset.cartQtyChange || 0);
    const next = Math.max(0, Number(input.value || 0) + delta);
    input.value = next;
    await fetch(`${this.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity: next }) });
    await this.refresh();
  }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', LoftyCartDrawer);
